export enum SmartCreateFeedbackVariant {
	ROVO = 'rovo',
	CREATE_WITH_ROVO = 'create-with-rovo',
}

export interface SmartCreateFeedbackProps {
	/**
	 * The variant of the SmartCreateFeedback component (either "Rovo" or "Create with Rovo").
	 */
	variant?: SmartCreateFeedbackVariant;

	/**
	 * Callback function to close the SmartCreateFeedback component.
	 */
	onClose: () => void;

	/**
	 * Callback function to submit the feedback.
	 */
	onSubmit: () => void;

	/**
	 * Additional fields to log in thefeedback context.  This will be saved, so do not share UGC here.
	 */
	additionalFields?: object;
}
